// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Carte "Liste des pieces composant la documentation technique" + sa modale "Lire la suite".
   Geometrie reprise de \`.bcc-desc__docs-champ*\` (vue presta) et des styles inline de la vue acheteur,
   que ce composant remplace tous les deux. Palette fermee (#595959 titres, #f97316 orange, #374151
   texte). */

.lpc {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  min-height: 88px;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  background: rgba(215, 217, 217, 0.2);
  /* La carte NE SCROLLE PAS : le debordement est traite par la troncature + la modale, pas par une
     barre de defilement interne que rien ne signale. */
  overflow: hidden;
}

.lpc__label {
  flex-shrink: 0;
  padding: 1rem 1.25rem 0.4rem;
  color: #595959;
  font-size: 1.3rem;
  font-weight: 600;
  line-height: 1.3;
}

/* UNE ligne, coupee a l'ellipse. \`-webkit-line-clamp\` et non une troncature par nombre de
   caracteres : celle-ci ne connait pas la largeur rendue ni les retours a la ligne de la saisie — elle
   coupait a 1 ligne ou a 5 selon le texte. Le clamp, lui, compte les lignes REELLEMENT rendues.
   Prefixes \`-webkit-\` : c'est la forme supportee partout, y compris Firefox, malgre son nom. */
.lpc__texte {
  flex: 1 1;
  min-height: 0;
  padding: 0 1.25rem 0.4rem;
  color: #374151;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  /* Preserve les retours a la ligne de la saisie, sans laisser un mot long elargir la carte. */
  white-space: pre-wrap;
  overflow-wrap: break-word;
}

.lpc__lien {
  flex-shrink: 0;
  align-self: flex-start;
  margin: 0 1.25rem 1.125rem;
  padding: 0;
  background: none;
  border: none;
  color: #f97316;
  font: inherit;
  text-decoration: underline;
  cursor: pointer;
}

/* --- Modale ------------------------------------------------------------------------------------ */
/* Le nom porte "overlay" : le verrou de scroll global (\`html:has([class*="overlay"])\`, index.css) fige
   donc la page derriere elle sans cablage supplementaire. */
.lpc-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  /* 1000 : meme etage que les autres modales de ces onglets (\`.bc-notif__modal-overlay\`). Rien
     d'autre n'est ouvert quand celle-ci l'est. */
  z-index: 1000;
  padding: 2rem;
}

.lpc-modal {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 8px;
  width: 100%;
  max-width: 72rem;
  max-height: 80vh;
  overflow: hidden;
}

.lpc-modal__bar {
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  padding: 1rem 2rem;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.lpc-modal__titre {
  font-size: 1.4rem;
  font-weight: 600;
  color: #2c3948;
}

/* C'est ICI que le scroll vit : une modale pleine hauteur l'assume, une carte de grille non. */
.lpc-modal__corps {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 2rem;
  color: #374151;
  font-size: 1.4rem;
  line-height: 1.6;
  white-space: pre-wrap;
  overflow-wrap: break-word;
}
`, "",{"version":3,"sources":["webpack://./src/composants/ListePiecesCard/ListePiecesCard.css"],"names":[],"mappings":"AAAA;;;YAGY;;AAEZ;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,oCAAoC;EACpC;uDACqD;EACrD,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;+FAG+F;AAC/F;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,6FAA6F;EAC7F,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,0BAA0B;EAC1B,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,aAAa;EACb,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,oGAAoG;AACpG;4DAC4D;AAC5D;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB;iDAC+C;EAC/C,aAAa;EACb,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,+FAA+F;AAC/F;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B","sourcesContent":["/* Carte \"Liste des pieces composant la documentation technique\" + sa modale \"Lire la suite\".\n   Geometrie reprise de `.bcc-desc__docs-champ*` (vue presta) et des styles inline de la vue acheteur,\n   que ce composant remplace tous les deux. Palette fermee (#595959 titres, #f97316 orange, #374151\n   texte). */\n\n.lpc {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  min-height: 88px;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.75rem;\n  background: rgba(215, 217, 217, 0.2);\n  /* La carte NE SCROLLE PAS : le debordement est traite par la troncature + la modale, pas par une\n     barre de defilement interne que rien ne signale. */\n  overflow: hidden;\n}\n\n.lpc__label {\n  flex-shrink: 0;\n  padding: 1rem 1.25rem 0.4rem;\n  color: #595959;\n  font-size: 1.3rem;\n  font-weight: 600;\n  line-height: 1.3;\n}\n\n/* UNE ligne, coupee a l'ellipse. `-webkit-line-clamp` et non une troncature par nombre de\n   caracteres : celle-ci ne connait pas la largeur rendue ni les retours a la ligne de la saisie — elle\n   coupait a 1 ligne ou a 5 selon le texte. Le clamp, lui, compte les lignes REELLEMENT rendues.\n   Prefixes `-webkit-` : c'est la forme supportee partout, y compris Firefox, malgre son nom. */\n.lpc__texte {\n  flex: 1;\n  min-height: 0;\n  padding: 0 1.25rem 0.4rem;\n  color: #374151;\n  line-height: 1.4;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  /* Preserve les retours a la ligne de la saisie, sans laisser un mot long elargir la carte. */\n  white-space: pre-wrap;\n  overflow-wrap: break-word;\n}\n\n.lpc__lien {\n  flex-shrink: 0;\n  align-self: flex-start;\n  margin: 0 1.25rem 1.125rem;\n  padding: 0;\n  background: none;\n  border: none;\n  color: #f97316;\n  font: inherit;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n/* --- Modale ------------------------------------------------------------------------------------ */\n/* Le nom porte \"overlay\" : le verrou de scroll global (`html:has([class*=\"overlay\"])`, index.css) fige\n   donc la page derriere elle sans cablage supplementaire. */\n.lpc-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* 1000 : meme etage que les autres modales de ces onglets (`.bc-notif__modal-overlay`). Rien\n     d'autre n'est ouvert quand celle-ci l'est. */\n  z-index: 1000;\n  padding: 2rem;\n}\n\n.lpc-modal {\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  border-radius: 8px;\n  width: 100%;\n  max-width: 72rem;\n  max-height: 80vh;\n  overflow: hidden;\n}\n\n.lpc-modal__bar {\n  flex-shrink: 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem 2rem;\n  background: #fff;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.lpc-modal__titre {\n  font-size: 1.4rem;\n  font-weight: 600;\n  color: #2c3948;\n}\n\n/* C'est ICI que le scroll vit : une modale pleine hauteur l'assume, une carte de grille non. */\n.lpc-modal__corps {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 2rem;\n  color: #374151;\n  font-size: 1.4rem;\n  line-height: 1.6;\n  white-space: pre-wrap;\n  overflow-wrap: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
